import { render, staticRenderFns } from "./expertForum.vue?vue&type=template&id=30321d4c&scoped=true"
import script from "./expertForum.vue?vue&type=script&lang=js"
export * from "./expertForum.vue?vue&type=script&lang=js"
import style0 from "./expertForum.vue?vue&type=style&index=0&id=30321d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30321d4c",
  null
  
)

export default component.exports